import { StorageContainer, UpdateStorageContainerInput } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface UpdateStorageContainerMutation {
  updateStorageContainer: StorageContainer
}

export interface UpdateStorageContainerVariables {
  id: GQL_ID
  input: UpdateStorageContainerInput
}

export const GQL_MUTATION_UPDATE_STORAGE_CONTAINER = gql`
  mutation updateStorageContainer($id: ID!, $input: UpdateStorageContainerInput!) {
    updateStorageContainer(id: $id, input: $input) {
      id
      container_id
      size
      type
      description
      is_active
      created_at
      updated_at
      displayName
    }
  }
`

export function useUpdateStorageContainer () {
  return useMutation<UpdateStorageContainerMutation, UpdateStorageContainerVariables>(
    GQL_MUTATION_UPDATE_STORAGE_CONTAINER
  )
}
